import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize,
} from "vee-validate";
import fr from "vee-validate/dist/locale/fr.json";
import * as rules from "vee-validate/dist/rules";
import ApolloClient from "apollo-boost";
import VueApollo from "vue-apollo";

const apolloClient = new ApolloClient({
  uri: "https://ccbobs.deta.dev/graphql",
});

Object.keys(rules).forEach((rule) => {
  extend(rule, rules[rule]);
});

localize("fr", fr);

Vue.component("ValidationProvider", ValidationProvider);

Vue.component("ValidationObserver", ValidationObserver);

const toastOptions = {
  // You can set your default options here
};

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
});

Vue.use(Toast, toastOptions);
Vue.use(VueApollo);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  apolloProvider,
  render: (h) => h(App),
}).$mount("#app");
